import React from "react";

export const updateButtons = (
  el: HTMLDivElement | null,
  setStatePrev: React.Dispatch<React.SetStateAction<boolean>>,
  setStateNext: React.Dispatch<React.SetStateAction<boolean>>,
  touchedRight: React.RefObject<boolean>
) => {
  const { scrollLeft, scrollWidth, clientWidth } = el as HTMLDivElement;
  const start = scrollLeft <= 2;
  const end = scrollLeft + clientWidth >= scrollWidth - 2;

  if (!touchedRight.current && scrollLeft > 2) {
    touchedRight.current = true;
  }
  setStatePrev(touchedRight.current && !start);
  setStateNext(!end);
};
